import React from 'react';
import {TouchableWithoutFeedback, Keyboard} from 'react-native';

export const DismissKeyboardView = ({children}: {children: any}) => {
  return children;
};
